import logo from '../assests/logo.png';
import main from '../assests/main.jpg'
import bg from '../assests/bg.jpg';
import aboutbg from '../assests/aboutbg.jpg';
import fruit from '../assests/fruit.jpg';
import flower from '../assests/flower.jpg';
import menu from '../assests/menu.jpg';
import chef from '../assests/chef.jpg';
import gallery from '../assests/gallery.jpg';
import gallery2 from '../assests/gallery2.jpg';
import gallery3 from '../assests/gallery3.jpg';

import gallery5 from '../assests/gallery5.jpg';
import gallery6 from '../assests/gallery6.jpg';
import gallery9 from '../assests/gallery9.jpg';

import gallery8 from '../assests/gallery8.jpg';
import findus from '../assests/findus.jpg';

export default {
    logo,
    main,
    bg,
    aboutbg,
    fruit,
    flower,
    menu,
chef,
gallery,
gallery2,
gallery3,

gallery5,
gallery6,
gallery9,
gallery8,
findus
};